// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__sqIh3","dragIcon":"Choice_dragIcon__1n2Om","left":"Choice_left__nto3_","input":"Choice_input__kM-cd"};